import { render, staticRenderFns } from "./face_feature_list_grouped.vue?vue&type=template&id=c0b8b0fc&lang=pug&"
import script from "./face_feature_list_grouped.vue?vue&type=script&lang=js&"
export * from "./face_feature_list_grouped.vue?vue&type=script&lang=js&"
import style0 from "./face_feature_list_grouped.vue?vue&type=style&index=0&id=c0b8b0fc&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports